import React from "react";
import { useIsSelected, useShape } from "../store/selectors";
import { ShapeSvg } from "./ShapeSvg";

export interface ShapeNodeProps {
  id: string;
}

let renderProbe: ((id: string) => void) | null = null;

/** Counts shape renders for the performance harness; unset in normal use. */
export const setShapeRenderProbe = (
  probe: ((id: string) => void) | null
): void => {
  renderProbe = probe;
};

/**
 * The one component per shape on the canvas. It subscribes to its own
 * shape and selection flag only, so a click or a drag elsewhere on the
 * map never re-renders it. Gestures find it through `data-shape-id` and
 * write scratch transforms straight onto this `<g>`.
 */
export const ShapeNode: React.FC<ShapeNodeProps> = React.memo(({ id }) => {
  const shape = useShape(id);
  const isSelected = useIsSelected(id);
  renderProbe?.(id);
  if (!shape || shape.hidden) return null;
  return (
    <g
      data-shape-id={id}
      data-shape-type={shape.type}
      data-selected={isSelected ? "true" : undefined}
      data-locked={shape.locked ? "true" : undefined}
    >
      <ShapeSvg shape={shape} />
    </g>
  );
});
ShapeNode.displayName = "ShapeNode";
